import Image from "next/image";
import { sbBlok } from "@/types/sb-types";
import bgArrows from "../../public/bg_graphics/arrows_down_color.svg";
import clsx from "clsx";

interface TeaserListProps {
  blok: sbBlok;
}

const TeaserList = ({ blok }: TeaserListProps) => {
  return (
    <section className="grid grid-cols-1 [&>*]:col-start-1 [&>*]:row-start-1">
      <div
        className={clsx(
          "grid-container opacity-60 pointer-events-none [&>*]:mt-0 [&_*]:h-full",
          {
            "pt-7 lg:pt-14":
              !!blok.spacing_top?.length &&
              blok.spacing_top[0].option === "large",
            "pt-14 lg:pt-[120px]":
              !!blok.spacing_top?.length &&
              blok.spacing_top[0].option === "x_large",
            "pt-[120px] lg:pt-[180px]":
              !!blok.spacing_top?.length &&
              blok.spacing_top[0].option === "xx_large",
            "pb-7 lg:pb-14":
              !!blok.spacing_bottom?.length &&
              blok.spacing_bottom[0].option === "large",
            "pb-14 lg:pb-[120px]":
              !!blok.spacing_bottom?.length &&
              blok.spacing_bottom[0].option === "x_large",
            "pb-[120px] lg:pb-[180px]":
              !!blok.spacing_bottom?.length &&
              blok.spacing_bottom[0].option === "xx_large",
          }
        )}
      >
        <div className="col-start-5 col-span-8 lg:col-start-9 lg:col-span-16 2xl:col-start-11 2xl:col-span-12">
          <div className="h-full relative">
            <Image
              src={bgArrows}
              alt="background arrows"
              fill
              sizes="100vw"
              className="object-cover"
            />
          </div>
        </div>
      </div>
      <div className="grid-container">
        <div className="col-start-1 col-span-3 md:col-start-2 md:col-span-2 lg:col-start-2 lg:col-span-14 2xl:col-start-5 2xl:col-span-24"></div>
        <div className="min-h-[60vh] flex relative pl-[60px]md:pl-0">
          <ul className="list-none grid w-full my-auto mx-0 gap-5 py-10 px-0 lg:grid-cols-3 lg:p-0 lg:gap-0 lg:gap-x-5 lg:gap-y-[60px]">
            {blok.teaser_list_items.map((i: sbBlok) => (
              <li key={i._uid} className="flex gap-[30px]">
                <span className="block w-[2px] h-full bg-[linear-gradient(0deg,rgba(21,20,20,0)_0%,rgba(236,105,26,1)_50%,rgba(21,20,20,0)_100%)]" />
                <div className="py-2.5 px-0">
                  <h3 className="m-0">{i.title}</h3>
                  <p className="my-2.5 mx-0">{i.content}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TeaserList;
